import { FormDetailComponentState } from "../../../components/form-detail/FormDetailComponentState";
import { FormInfo } from "../../../components/form-detail/FormInfo";
import { PersonInfo } from "../../../components/form-detail/PersonInfo";
import { Timeline } from "../../../components/form-detail/Timeline";
import { LoadingBoxFillComponent } from "../../../components/state/Loading";
import { Form } from "../../../../core/entities/form";
import { ContentBox } from "../../../components/structure/ContentBox";
import { ContentHeader } from "../../../components/structure/ContentHeader";
import { HeaderWithBack } from "../../../components/structure/HeaderWithBack";
import React from "react";
import {
    PageForbiddenScreen,
    PageNotFoundScreen,
    PageUnknownErrorErrorScreen
} from "../../public/ErrorPage/ErrorPage.Screen";

export interface FormDetailViewModelProps {
    form?: Form;
    handleBack: () => void;
    componentState: FormDetailComponentState;
}

export function FormDetailComponent({
    form,
    handleBack,
    componentState
}: FormDetailViewModelProps) {
    if (componentState === FormDetailComponentState.Loading) {
        return <LoadingBoxFillComponent />;
    }

    if (componentState === FormDetailComponentState.NotFound) {
        return <PageNotFoundScreen />;
    }

    if (componentState === FormDetailComponentState.Forbidden) {
        return <PageForbiddenScreen />;
    }

    if (componentState === FormDetailComponentState.Error) {
        return <PageUnknownErrorErrorScreen />;
    }

    return (
        <>
            <HeaderWithBack onBack={handleBack}>
                <p className="text-xm font-semibold text-secondary-gray-dark pb-4">
                    {form!.citizenName}
                </p>
                <p className="text-n font-normal text-secondary-gray-dark">
                    ID: {form!.documentId?.toUpperCase() ?? "N/A"}
                </p>
            </HeaderWithBack>
            <div className="flex xl:flex-row sm:max-xl:flex-col xl:space-x-32 sm:max-xl:space-x-0">
                <div className={"flex flex-col flex-1"}>
                    <ContentBox className={"animate-fade-in"}>
                        <ContentHeader className={"!mb-0"}>
                            Attestinfo
                        </ContentHeader>
                        <FormInfo form={form!} />
                    </ContentBox>
                    <ContentBox className={"animate-fade-in"}>
                        <ContentHeader className={"!mb-0"}>
                            Personinfo
                        </ContentHeader>
                        <PersonInfo form={form!} />
                    </ContentBox>
                </div>
                <ContentBox className={"flex-1 animate-fade-in h-fit"}>
                    <ContentHeader>Tidslinje</ContentHeader>
                    <Timeline events={form?.events!} />
                </ContentBox>
            </div>
        </>
    );
}
